import { Box, Skeleton, Typography } from "@mui/material"
import { useState, useEffect } from "react"

import Image from "next/image"

interface AsyncImageProps {
  src: string
  alt: string
  width: number
  height: number
  style?: React.CSSProperties;
  title?: string
  onClick?: () => void
}

export default function AsyncImage({ src, alt, width, height, title, style, onClick }: AsyncImageProps) {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    const img = new window.Image()
    img.src = src
    img.onload = () => setLoaded(true)
  }, [src])

  return loaded ? (
    <Box position='relative' overflow='hidden' onClick={onClick} display='flex' justifyContent='center' alignItems='center' sx={{ width, height, cursor: onClick ? 'pointer' : 'inherit' }}>
      <Image src={src} alt={alt} width={width} height={height} style={style} />
      {title?.length ? <Typography sx={{ position: 'absolute', backgroundColor: '#212121', borderRadius: '4px ', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', bottom: 6, fontSize: 10, paddingY: '2px', paddingX: '4px', maxWidth: width - 8 }}>{title}</Typography> : null}
    </Box>
  ) : (
    <Skeleton variant="rectangular" height={height} width={width} sx={{ borderRadius: "0.5rem" }} />
  )
}
